function obterLarguraColunaReferencia(key: string): number {
    switch (key?.toUpperCase()) {
        case '"GG"':
            return 600;
        case '"G"':
            return 450;
        case '"M"':
            return 300;
        default:
            return 150;
    }
}
export const larguraPrimeiraColuna = 35
export const larguraColunaOrdem = 70;
export const larguraColunaCodigo = 60;
export const larguraColunaReferencia = 120;
const storedValueLarguraColunaDescricao = obterLarguraColunaReferencia(sessionStorage.getItem('larguraColunaDescricao'));
export const larguraColunaDescricao = storedValueLarguraColunaDescricao;

